import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import CoaResultsPage from '../../CoaResultsPage';
import { usePublicCoaResults } from '../../hooks/usePublicCoaResults';

export default function CoaResultsContainer() {
  const params = useParams();
  const issuanceId = String(params.issuanceId || '').trim();

  const landingIndex = useMemo(() => {
    const raw = params.index;
    if (raw == null || raw.trim() === '') return 0;

    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed) || parsed < 0) return 0;
    return parsed;
  }, [params.index]);

  const { coas, isLoading, error, retry } = usePublicCoaResults(issuanceId, landingIndex);

  return (
    <CoaResultsPage
      activeCoas={coas}
      loading={isLoading}
      error={error}
      onRetry={retry}
    />
  );
}